import React from 'react';
import { FiCode, FiLock } from 'react-icons/fi';

const DevModeToggle = ({ 
  isDevMode, 
  onToggle, 
  disabled = false, 
  deviceId,
  className = "" 
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onToggle(deviceId, isDevMode ? 'disable_developer_mode' : 'enable_developer_mode');
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={disabled}
      className={`
        relative inline-flex h-7 w-14 items-center rounded-full transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 shadow-sm
        ${isDevMode 
          ? 'bg-yellow-600 hover:bg-yellow-700 shadow-yellow-200' 
          : 'bg-gray-200 hover:bg-gray-300 shadow-gray-200'
        }
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${className}
      `}
      title={isDevMode ? 'Deshabilitar modo desarrollador' : 'Habilitar modo desarrollador'}
    >
      {/* Círculo del switch */}
      <span
        className={`
          inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-all duration-300 ease-in-out
          ${isDevMode ? 'translate-x-8' : 'translate-x-1'}
        `}
      />

      {/* Icono del estado (dentro del círculo) */}
      <div className={`
        absolute left-1.5 flex items-center justify-center transition-all duration-300 ease-in-out
        ${isDevMode ? 'opacity-0 scale-0' : 'opacity-100 scale-100'}
      `}>
        <FiLock size={10} className="text-gray-500" />
      </div>

      <div className={`
        absolute right-1.5 flex items-center justify-center transition-all duration-300 ease-in-out
        ${isDevMode ? 'opacity-100 scale-100' : 'opacity-0 scale-0'}
      `}>
        <FiCode size={10} className="text-white" />
      </div>
    </button>
  );
};

export default DevModeToggle;
